import {format, formatISO} from "date-fns";
import { result } from "lodash";


import { ObservationSessionMode } from "../../../../models/ObservationSessionMode";


export default class InitManager 
{

  static initDuplicateValueBag(props, valueBag)
  {
    valueBag["gcid"] = props.userSession.gcid;
    valueBag["inspector"] = props.userSession.uid;
    valueBag["location"] = props.userSession.currentLocationId;
    valueBag["inspectiondate"] = formatISO(new Date());
    return valueBag;
  }

  static initFreshValueBag(props)
  {
      var valueBag =  
      {
        gcid: props.userSession.gcid,
        inspector: props.userSession.uid,
        location: props.userSession.currentLocationId,
        inspectiondate: formatISO(new Date()),
      };
      return valueBag;
    }

    static initNewValueBag(schema, valueBag)
    {
        schema.categories.forEach((cat) => 
        {
            cat.groups.forEach((group) => 
            {
              group.cards.forEach((card) => 
              {
                if ((card.default) && (card.default.enabled)) 
                {
                  if (card.default.calcType === "constant") 
                  {
                    valueBag[card.id] = card.default.defaultValue;
                  }
                  else if (card.default.calcType === "derived") 
                  {
                    if (card.default.defaultValue === "today") 
                    {
                      valueBag[card.id] = format(new Date(), card.display.format);
                    }
                  }
                }
              });
            });
          });
          return valueBag;
    }

    static initCategoryState(schema, observationSessionMode)
    {
      var updatedCategoryStateBag = {};
      schema.categories.forEach((cat, catIndex) =>
      {
        updatedCategoryStateBag[cat.id] = (observationSessionMode === ObservationSessionMode.UPDATE) ? cat.updatesAllowed : cat.initEnabled;
      });
      return updatedCategoryStateBag;
    }




    static initRequiredState(schema, observationSessionMode) 
    {
      console.log("Getting initRequiredState:");
      // NOTE that if performance is an issue, then unroll to "for". I can't believe it will be given the number of elements. But who knows?
      if (observationSessionMode === ObservationSessionMode.UPDATE_UNDERINSPECTION) return [];
      var resultBag = {};
      schema.categories.forEach((cat, catIndex) => 
      {
        if (observationSessionMode === ObservationSessionMode.UPDATE_UNDERINSPECTION) return;
        cat.groups.forEach((group, groupIndex) =>
        {
          group.cards.filter((card) => ( card.validation && card.validation.required)).forEach(card => 
            {
              console.log("Card Validation:")
              console.info(card.validation);
              var validationObject = {
                id: (card.validation.id) ? card.validation.id: card.id,
                value: {
                required: true,
                message: card.validation.requiredMessage
                  ? card.validation.requiredMessage
                  : card.title + " is required"
                }
              };
              resultBag[validationObject.id] = validationObject.value;
            }
          );        
        }
        )
      });
      return resultBag;

    }

    static initOnChangeEvents(schema, observationSessionMode) 
    {
      // pre-register any on change events so that we don't have to rip through the entire schema to find them onchange
      var onChangeEventsBag = {};

      schema.categories.forEach((cat, catIndex) =>
      {
        cat.groups.forEach((group, index) => 
        {
            group.cards.filter((card) => (card.onChange)).forEach((card) =>
            {

              // It's possible that this card ALREADY HAS an onChange, generated by being part of a
              // calcFormula for a previously processed card with a calcFormula. 
              if (!onChangeEventsBag[card.id]) 
              {
                onChangeEventsBag[card.id] = card.onChange;
              }
              else {
                // we must INJECT the card.onChange values into the EXISTING onChange object
                for (var e = 0; e < card.onChange.length; e++) {
                  onChangeEventsBag[card.id].push(card.onChange[e]);
                }
              }
              if (card.calcFormula) 
              {
                // this card has a calculation formula. Parse all fields in the formula and add them because
                // a change to ANY of these values should trigger a recalc. Calc cards are a little different
                // because we don't want to put the onChange recalc on EACH card in the formula. We only want to
                // put it in the calc card. But there's a problem if the original card already has an onChange
                // on it. We need to trigger the onChangeEvent on the FORMULA value, not on the calc card value.
                // TBD - how do we trigger the recalc when a "source" value in the formula changes? We could
                // literally INJECT the onChange into the source card's onChange (or create one if it doesn't exist.)
                // parse all "source" formula cards
                const regexp = /\[[^\]]*\]/gm
                var calcFields = [...card.calcFormula.matchAll(regexp)];
                // now for EACH calcField, either ADD an onChange event to it, or INJECT it into its existing one.
                for (var c = 0; c < calcFields.length; c++) {
                  var calcField = calcFields[c][0];
                  var calcFieldId = calcField.replace("[", "").replace("]", "");
                  var recalcState = { "targetCard": card.id, "calcFormula": card.calcFormula };
                  if (!onChangeEventsBag[calcFieldId]) 
                  {
                    // inject a new onChange for this field
                    var newOnChange = [{ "recalcState": recalcState }];
                    onChangeEventsBag[calcFieldId] = newOnChange;
                  }
                  else {
                    // card already HAS an onChange. Just inject the new recalcState into the OnChange
                    onChangeEventsBag[card.id].push({ "recalcState": recalcState });
                  }
                }
              }
            })
        })
      });
      return onChangeEventsBag;
    }



}


